import { apiClient } from './api'

export type StrategyHealth = 'on_track' | 'at_risk' | 'off_track' | 'no_dates' | 'achieved' | 'dropped'
export type DeliveryType = 'portfolio' | 'program' | 'project'

export interface StrategyKeyResult {
  id: number
  objective_id: number
  title: string
  unit: string | null
  start_value: number
  target_value: number
  current_value: number | null
  progress: number
  status: string
  checkins: Array<{ value: number; previous: number | null; note: string | null; by: string | null; at: string }>
  updated_at: string | null
}

export interface StrategyObjective {
  id: number
  title: string
  description: string | null
  category: string | null
  status: string
  period: string | null
  start_date: string | null
  target_date: string | null
  owner_id: number | null
  owner_name: string | null
  progress: number
  expected_progress: number | null
  health: StrategyHealth
  key_results: StrategyKeyResult[]
  delivered_by: Array<{ link_id: number; type: DeliveryType; id: number; name: string; status: string; progress: number | null }>
}

export interface StrategyOverview {
  as_of: string
  objectives: StrategyObjective[]
  summary: { objectives: number; active: number; average_progress: number | null; by_health: Partial<Record<StrategyHealth, number>> }
  alignment: {
    open_projects: number
    aligned_projects: number
    alignment_percent: number | null
    unaligned: Array<{ id: number; name: string; status: string }>
  }
}

/** Strategy — backend/app/api/v1/endpoints/strategy.py (+ /governance/objectives for CRUD). */
export const strategyService = {
  overview: () => apiClient.get<StrategyOverview>('/api/v1/strategy/overview').then((r) => r.data),
  link: (objectiveId: number, type: DeliveryType, id: number) =>
    apiClient.post<StrategyOverview>(`/api/v1/strategy/objectives/${objectiveId}/links`, { type, id }).then((r) => r.data),
  unlink: (objectiveId: number, linkId: number) =>
    apiClient.delete<StrategyOverview>(`/api/v1/strategy/objectives/${objectiveId}/links/${linkId}`).then((r) => r.data),
  checkin: (krId: number, value: number, note?: string) =>
    apiClient.post<StrategyOverview>(`/api/v1/strategy/key-results/${krId}/checkins`, { value, note }).then((r) => r.data),
}
